import { render, staticRenderFns } from "./ContractorsNew.vue?vue&type=template&id=2e27cf18"
import script from "./ContractorsNew.vue?vue&type=script&lang=ts"
export * from "./ContractorsNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e27cf18')) {
      api.createRecord('2e27cf18', component.options)
    } else {
      api.reload('2e27cf18', component.options)
    }
    module.hot.accept("./ContractorsNew.vue?vue&type=template&id=2e27cf18", function () {
      api.rerender('2e27cf18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/ContractorsNew.vue"
export default component.exports